/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { useTranslation } from 'react-i18next'
import { intlFormat } from '../../../../helpers/money'
import useUser from '../../../Shared/UserProvider/useUser'

const metadataStyle = css`
    font-size: 0.7em;
    color: grey;
    line-height: normal;
    margin-bottom: 0;
`

const PricePerUnit = ({orderItem}) => {
    const [t] = useTranslation()
    const {user} = useUser()
    const pricedByUnit = orderItem.item?.pricedByUnit

    return (
      <p css={metadataStyle}>{t('item.priced_by_unit.price_per_unit', {
          value: intlFormat(orderItem.unitPrice, user.getCompanyCurrency(), user.getCompanyLocale()),
          unit: t(`measurement_unit.symbols.${pricedByUnit.unit}`),
      })}
      </p>
    )
}

const OrderItemPricingMetadata = ({orderItem, ...props}) => {
    const [t] = useTranslation()

    const pricedByUnit = orderItem.item?.pricedByUnit
    const sellableUnit = orderItem?.sellableUnit
    const sellingOption = orderItem.item?.sellingOptions.find(so => so.measurementUnit.type === sellableUnit.type)

    const isPricedByWeighOrVolumeAndSoldByCount =
      pricedByUnit?.type !== 'COUNT' &&
      sellableUnit?.type === 'COUNT'

    if (!pricedByUnit) {
        return null
    }

    if (isPricedByWeighOrVolumeAndSoldByCount) {
        if (!sellingOption) {
            return null
        }

        return (
          <div className={props.className}>
              <PricePerUnit orderItem={orderItem} />
              <p css={metadataStyle}>
                  {t('order.order_item.pricing_metadata.estimated_weight_per_unit', {
                      weight: sellingOption.conversionRate,
                      unit: t(`measurement_unit.symbols.${pricedByUnit.unit}`),
                  })}
              </p>
          </div>
        )
    }

    if (pricedByUnit.type === 'WEIGHT' && sellableUnit.type === 'WEIGHT') {
        return <PricePerUnit orderItem={orderItem} />
    }

    return (
      <span css={metadataStyle}>
        {t('order.order_item.pricing_metadata.priced_by_count')}
      </span>
    )
}

export { OrderItemPricingMetadata }
